import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography,
  Button,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const AppFallback = ({ classes, errorInfo }) => {
  console.log(errorInfo)
  return (
    <div className={classes.container}>
      <Paper className={classes.paper}>
        <Typography variant='h6'>ReVUe has encountered an error.</Typography>
        <Button
          className={classes.reloadBtn}
          variant="contained"
          color="primary"
          size="small"
          onClick={() => window.location.reload()}
        >
          Reload
        </Button>
        <Accordion className={classes.accordion}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            classes={{
              root: classes.accordionSummary,
              content: classes.accordionSummaryContent
            }}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant='subtitle2'>View details</Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            {errorInfo?.error && 
              <>
                <Typography variant='h6'>Error:</Typography>
                <Typography variant='body2'>
                  {errorInfo.error.message ?? errorInfo.error.toString()}
                </Typography>
              </>
            }
            {errorInfo?.info?.componentStack && 
              <>
                <Typography variant='h6'>Component stack:</Typography>
                <Typography variant='body2' className={classes.componentStack}>
                  {errorInfo.info.componentStack}
                </Typography>
              </>
            }
          </AccordionDetails>
        </Accordion>
      </Paper>
    </div>
  )
}
const styles = theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 24
  },
  reloadBtn: {
    margin: '1rem 0',
    fontSize: '0.8rem',
  },
  accordion: {
    boxShadow: 'none',
    position: 'static',
    textAlign: 'center',
    margin: '0 !important',
  },
  accordionSummary: {
    display: 'inline-flex',
    marginLeft: '0.5rem',
  },
  accordionSummaryContent: {
    margin: '8px 0'
  },
  accordionDetails: {
    backgroundColor: '#ffe5ec',
    borderRadius: '0.5rem',
    textAlign: 'start',
    flexDirection: 'column'
  },
  componentStack: {
    whiteSpace: 'pre-wrap',
    maxHeight: '50vh',
    overflow: 'auto'
  }
});

export default withStyles(styles)(AppFallback);
